var map = {
	"./1-1.png": "./src/assets/panel/1-1.png",
	"./2-1.png": "./src/assets/panel/2-1.png",
	"./3-1.png": "./src/assets/panel/3-1.png",
	"./4-1.png": "./src/assets/panel/4-1.png",
	"./5-1.png": "./src/assets/panel/5-1.png",
	"./6-1.png": "./src/assets/panel/6-1.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/panel sync recursive ^\\.\\/.*\\-1\\.png$";